import { render, staticRenderFns } from "./cercaOrdini.html?vue&type=template&id=4df16dc2&"
import script from "./CercaOrdini.vue?vue&type=script&lang=js&"
export * from "./CercaOrdini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports